export default __webpack_public_path__ + "static/media/tick-yellow.89628bd8.svg";